import { IconHome, IconKey, IconBuildingSkyscraper } from '@tabler/icons-react';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { activeTab } from '../types/dashboard.types';

interface Props {
  activeTab: activeTab;
  onTabChange: (tab: activeTab) => void;
  preSaleCount: number;
  rentCount: number;
  secondaryCount: number;
  visibleTabs?: activeTab[];
}

const NavigationTabDashboard = ({
  activeTab,
  onTabChange,
  preSaleCount,
  rentCount,
  secondaryCount,
  visibleTabs = ['rent', 'secondary', 'pre-sale'],
}: Props) => {
  return (
    <Card className="mb-4">
      <CardBody>
        <Nav tabs>
          {visibleTabs.includes('rent') && (
            <NavItem>
              <NavLink
                className={activeTab === 'rent' ? 'active' : ''}
                onClick={() => onTabChange('rent')}
                style={{ cursor: 'pointer' }}
              >
                <IconKey size={16} className="me-2" />
                Renta ({rentCount})
              </NavLink>
            </NavItem>
          )}
          {visibleTabs.includes('secondary') && (
            <NavItem>
              <NavLink
                className={activeTab === 'secondary' ? 'active' : ''}
                onClick={() => onTabChange('secondary')}
                style={{ cursor: 'pointer' }}
              >
                <IconBuildingSkyscraper size={16} className="me-2" />
                Secondary ({secondaryCount})
              </NavLink>
            </NavItem>
          )}
          {visibleTabs.includes('pre-sale') && (
            <NavItem>
              <NavLink
                className={activeTab === 'pre-sale' ? 'active' : ''}
                onClick={() => onTabChange('pre-sale')}
                style={{ cursor: 'pointer' }}
              >
                <IconHome size={16} className="me-2" />
                PreVenta ({preSaleCount})
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </CardBody>
    </Card>
  );
};

export default NavigationTabDashboard;
